<template>
  <div>
    <slot></slot>

    <div class="w3-main" style="margin-left:200px;">

      <div class="w3-row w3-small" style="border-bottom: 1px solid #f3efee; height:100%;height: 100vh;">
        <form class="" @submit.prevent="addIssue">

          <div class="w3-col l7 s12 w3-display-container" style="border-right: 1px solid #f3efee;height: 100vh;">
            <WorkspaceTopbar>
              <template slot="header">
                {{workspace.name}} <i class="fa fa-chevron-right fa-xs"></i>  New Issue
              </template>

              <template slot="right-header">
                <router-link :to="{ name: 'issues' }">
                  <span class="w3-tag w3-white">Cancel</span>&nbsp;
                </router-link>
                <span @click.prevent="addIssue" class="w3-tag w3-round w3-white w3-border">Save</span>
              </template>

              <template slot="new-issue">
                <label class="w3-text-white"></label>
              </template>
            </WorkspaceTopbar>

            <div class="w3-padding input-title-detail">
              <p>
                <textarea v-model="formData.title" class="input-1" rows="2" name="" value="" placeholder="Issue title"></textarea>
              </p>

              <contenteditable class="editable" :placeholder="'Add some details...'" v-model="formData.description" tag="div" :contenteditable="isEditable" :noHTML="false" :noNL="false" @returned="enterPressed" />

              <!-- <div v-model="formData.description" placeholder="Add some details... :]" contenteditable="true"></div> -->

                <!-- <textarea v-model="formData.description" class="input-2" rows="17" type="text" name="" value="" placeholder="Add some details..."></textarea> -->

              <div class="w3-display-bottomleft w3-padding">
                <label for="file-input" style="cursor: pointer;" title="Attach images, files or videos.">
                  <span class="w3-round w3-padding-small w3-borderx" style="border: 1px dashed #ccc">
                    <i class="fa fa-paperclip fa-lg w3-text-grey"></i> &nbsp;
                    Attach files etc.
                  </span>
                </label>
                <input type="file" name="" id="file-input" ref="myfile" v-on:change="handleFileUpload()" style="display: none;">
              </div>

            </div>
          </div>

          <div class="w3-col l5 s12" style="background-color: #f8f9fb; height: 100vh;">
            <IssueRightDetail
              :formData="formData"
              :ws_issue_status="ws_issue_status"
              :ws_issue_label="ws_issue_label"
              :ws_issue_priority="ws_issue_priority"
            />

          </div>




        </form>
      </div>
    </div>
    <!-- <WorkspaceTopbar/> -->

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import router from '@/router'
import { isEmpty, formatBytes } from '@/utils/utils'
import WorkspaceTopbar from "@/components/workspace/WorkspaceTopbar.vue"
import IssueRightDetail from "@/components/workspace/issues/IssueRightDetail.vue"

export default {
  name: 'IssueNew',

  data(){
    return{
      errors: [],
      file: '',
      formData: {
        title: '',
        description: '',
        status: 4,
        priority: 5,
        assignee: '',
        labels: '',
        project: '',
      },
      notificationSystem: {
        options: {
          error: {
            position: "bottomRight"
          },
        }
      },
      // #
      isEditable: true,
      message: "hello"
    }
  },

  components:{
    WorkspaceTopbar,
    IssueRightDetail
  },

  methods: {
    ...mapActions('workspace', ['newIssue', 'addIssueFiles']),
    ...mapMutations('workspace', ['add_files']),

    enterPressed(){
      alert('Enter Pressed');
    },

    handleFileUpload: function () {
      this.file = this.$refs.myfile.files[0]

      // console.log(this.file);

      if (this.file) {
        let form = new FormData();
        form.append('workspace', this.workspace.id)
        form.append('created_by', this.user.id)
        form.append('file', this.file)
        // const payload = {data: form}
        this.addIssueFiles(form)
      }

    },

    addIssue: function(){
      //
      // console.log('title: '+this.formData.title);
      // console.log('description: '+this.formData.description);
      // console.log('status: '+this.formData.status);
      // console.log('priority: '+this.formData.priority);
      // console.log('assignee: '+this.formData.assignee);
      // console.log('labels: '+this.formData.labels);
      // console.log('project: '+this.formData.project);
      // console.log('----------------------------------------------------------');

      this.errors = [];

      if (isEmpty(this.formData.title)) {
        const t_msg = "The Issue's title cannot be empty."
        this.$toast.error(t_msg, 'Error:', this.notificationSystem.options.error)
        this.errors.push("Title required.");
      }else if(this.formData.title.length > 200){
        const t_msg = "The Issue's title cannot be more than 200 characters."
        this.$toast.error(t_msg, 'Error:', this.notificationSystem.options.error)
        this.errors.push("Title max reached.");
      }

      if (!isEmpty(this.formData.description)) {
        if (this.formData.description.length > 4000) {
          const d_msg = "The Issue's description cannot be more than 4000 characters."
          this.$toast.error(d_msg, 'Error:', this.notificationSystem.options.error)
          this.errors.push("Max character reached.");
        }
      }

      if(!this.errors.length){

        const data = {
          name: this.formData.title,
          description: this.formData.description,
          workspace: this.workspace.id,
          created_by: this.user.id,
          status: this.formData.status,
          priority: this.formData.priority,
          assigned_to: this.formData.assignee,
          label: this.formData.labels,
          project_id: this.formData.project,

        }
        this.newIssue(data).then( resp => {
          // this.$toast.error('Illegal operation', 'Error', this.notificationSystem.options.error)
          this.$toast.success(`"${this.formData.title}" added to issues.`, 'Issue Created', this.notificationSystem.options.success)
          router.push({name: 'issues', params: {slug: this.workspace.slug} })
        })

      }

    },


    fileFormat: function (val, size) {
      // const file = this.server_url + val
      const file = val
      const file_name = val.split(this.media_url).pop()
      const file_size = formatBytes(size)

      console.log('fn: '+file_name);

      if (this.imageFileTypes.includes(val.split('.').pop())) {
        return `<div class="w3-padding-small"><img class="center" width="350px" src="${file}"/></div><br/>`
      } else {
        return `<a href="${file}"><div class="file w3-border w3-round w3-padding" contenteditable="false"><i class='fa fa-file-alt grey'></i>
        ${file_name} | ${file_size}</div></a><br/>`
      }
    }
  },

  watch: {
    watchMessage(message){
      if (message == 1) {
        if (this.addFileForm.data.file) {
          const image_file = this.fileFormat(this.addFileForm.data.file, this.addFileForm.data.size)
          const final = this.formData.description.concat(image_file)
          this.formData.description = final
        }
        this.add_files({status: 3})
      }
      else if (message == 2) {
        this.$toast.error(this.addFileForm.error.file[0], 'Oops!', this.notificationSystem.options.error)

        this.add_files({status: 3})
      }
    }
  },

  created: function () {
    // console.log(this.ws_issue_status);
  },

  mounted: function () { },

  computed: {
    ...mapState('workspace', ['addFileForm', 'imageFileTypes']),
    ...mapState('auth', ['server_url', 'media_url']),

    ...mapGetters('auth', ['auth_state', 'user', 'isLoggedIn', 'workspaces']),
    ...mapGetters('workspace', ['ws_issue_status', 'ws_issue_priority', 'ws_issue_label']),

    workspace: function(){
      const result = this.workspaces.find( ({ slug }) => slug === this.$route.params.slug );
      return result;
    },

    watchMessage: function () {
      return this.addFileForm.status;
    },

    fileExt: function (value) {
      return value.split('.').pop()
    },

  }
}
</script>

<style scoped>
textarea{
  outline: none;
}

.grey{
  color: #e2e2e2;
}

[contenteditable=true]:empty:before{
  content: attr(placeholder);
  pointer-events: none;
  display: block; /* For Firefox */
  color: grey;
}

div[contenteditable=true] {
  /* border: 1px dashed #AAA; */
  /* width: 290px; */
  padding: 5px;
  outline: none;
}

.input-title-detail{
  /* border: none; */
}

a{
  text-decoration: none;
}

.input-1, .input-2{
  border: none;
  width: 100%;
  resize: none;
  /* height: auto; */
}

.input-1{
  /* height: 60px; */
  font-size: 22px
}

.new-issue-detail{
  margin-bottom: 20px;
}

</style>
